const TOKEN_KEY = 'card-secret-token'
const USER_KEY = 'card-secret-user'

export function isLoggedIn() {
  return !!localStorage.getItem(TOKEN_KEY)
}

export function login(username, token) {
  localStorage.setItem(TOKEN_KEY, token || '1')
  localStorage.setItem(USER_KEY, username || '管理员')
}

export function logout() {
  localStorage.removeItem(TOKEN_KEY)
  localStorage.removeItem(USER_KEY)
}

export function getDisplayName() {
  return localStorage.getItem(USER_KEY) || '管理员'
}

export function getToken() {
  return localStorage.getItem(TOKEN_KEY)
}
